/**
 * 教师管理 store 模块
 */
import {
  getTeachers,
  getTeacher,
  createTeacher as apiCreate,
  updateTeacher as apiUpdate,
  deleteTeacher as apiDelete
} from '@/api/teachers'
import { normalizeGenderValue } from '@/utils/gender'

function normalizeTeacher(raw) {
  if (!raw) return null
  return {
    ...raw,
    teacherId: raw.teacher_id ?? raw.teacherId,
    userId: raw.user_id ?? raw.userId,
    name: raw.teacher_name ?? raw.name ?? raw.real_name ?? raw.realName ?? '',
    gender: normalizeGenderValue(raw.gender ?? raw.sex),
    contact: raw.contact ?? raw.phone ?? raw.mobile ?? raw.mobile_phone ?? '',
    dingId: raw.ding_id ?? raw.dingId ?? raw.ding_user_id ?? raw.dingUserId ?? '',
    createBy: raw.create_by ?? raw.createBy,
    createTime: raw.create_time ?? raw.createTime,
    updateBy: raw.update_by ?? raw.updateBy,
    updateTime: raw.update_time ?? raw.updateTime
  }
}

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    error: null
  },
  getters: {
    teachers: state => state.list,
    loading: state => state.loading,
    error: state => state.error,
    /** 教师选项列表，用于下拉选择 */
    teacherOptions: state =>
      state.list.map(t => ({
        label: t.name || `教师 ${t.userId}`,
        value: t.userId
      }))
  },
  mutations: {
    SET_LIST(state, list) {
      state.list = (list || []).map(normalizeTeacher).filter(Boolean)
    },
    SET_LOADING(state, v) {
      state.loading = !!v
    },
    SET_ERROR(state, err) {
      state.error = err
    }
  },
  actions: {
    async fetchList({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const res = await getTeachers()
        const list = res.data ?? res.list ?? (Array.isArray(res) ? res : [])
        commit('SET_LIST', list)
        return { list: (list || []).map(normalizeTeacher).filter(Boolean) }
      } catch (e) {
        commit('SET_ERROR', e.message)
        throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchOne(_, userId) {
      const res = await getTeacher(userId)
      const data = res.data ?? res
      return normalizeTeacher(data)
    },
    async create({ rootState }, payload) {
      const data = {
        user_id: payload.userId ?? payload.user_id,
        teacher_name: (payload.name ?? payload.teacher_name ?? '').toString().trim(),
        contact: (payload.contact ?? '').toString().trim(),
        create_by: rootState.currentUser?.name ?? rootState.currentUser?.username ?? 'admin'
      }
      if (payload.gender !== undefined && payload.gender !== null && payload.gender !== '') {
        data.gender = normalizeGenderValue(payload.gender)
      }
      if (payload.dingId != null && payload.dingId !== '') data.ding_id = payload.dingId
      await apiCreate(data)
    },
    async update({ rootState }, { userId, data }) {
      const payload = {
        teacher_name: (data.name ?? data.teacher_name ?? '').toString().trim(),
        contact: (data.contact ?? '').toString().trim(),
        update_by: rootState.currentUser?.name ?? rootState.currentUser?.username ?? 'admin'
      }
      if (data.gender !== undefined && data.gender !== null && data.gender !== '') {
        payload.gender = normalizeGenderValue(data.gender)
      }
      if (data.dingId != null && data.dingId !== '') payload.ding_id = data.dingId
      await apiUpdate(userId, payload)
    },
    async remove(_, userId) {
      await apiDelete(userId)
    }
  }
}
